import styled from "styled-components";

export const Wrap = styled.div`
  height: 100%;
  background-color: #F3F6FF;
  .left-section {
    width: 240px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #ffffff;
    height: 100%;
    z-index: 4;
  }
  .right-section {
    width: ${({showSidebar})=> showSidebar ? "calc(100% - 240px)" : "100%"};
    margin-left: ${({showSidebar})=> showSidebar ? "240px" : "0px"};
    position: relative;
    min-height: 100vh;
    .handset-header{
      display: none;
    }
  }
  section .container-fluid {
    padding: 0 48px 0 48px;
    .padding-gap {
      padding-bottom: 24px;
    }
  }
  @media screen and (max-width: 1240px) {
    .left-section {
      display: none;
    }
    .right-section {
      width: 100%;
      margin-left: 0;
      .desktop-header{
        display: none;
      }
      .handset-header{
       display: block;
      }
    }
    section .container-fluid {
      padding: 16px 16px 0;
    }
  }
  @media screen and (min-width: 1600px) {
    section .container-fluid {
      width: 1320px;
      padding: 24px 30px 0;
    }
  }
  @media screen and (min-width: 1920px) {
    section .container-fluid {
      padding: 24px 0;
    }
  }
`;
